import { URL } from "../constants/constants";

export const getLoginUrl = () => {
  const port = location.port ? `:${location.port}` : '';

  // If you have configured multiple OIDC providers, then, you can update this URL to /login.
  // It will show a Spring Security generated login page with links to configured OIDC providers.
  // return `//${location.hostname}${port}/oauth2/authorization/oidc`;
  return `//${location.hostname}${port}/connect` + location.pathname + location.search;
};

export const inFooterPage = () => {
  const pathname = window.location.pathname;
  return pathname.includes(URL.LEGAL_NOTICE) || pathname.includes(URL.PRIVACY_POLICY) || pathname.includes(URL.TERMS_OF_SERVICE);
}

export const inClaimPage = () => {
  const pathname = window.location.pathname;
  return pathname.includes(URL.CLAIM);
}